module.exports = __webpack_public_path__ + "img/facebook.cac41548.svg";